<template>
  <div class="pa-4" style="background-color: white;">
    <div v-if="showSegmentType == 'starten'" class="mb-4">
      <v-row>
        <v-col
          cols="12"
          class="headline pa-2"
          style="border-bottom: 4px solid #f2f2f2"
        >
          <b>Jetzt DentalJack starten</b>
          <span class="hidden-xs-only"
            >&nbsp;|&nbsp; inkl. AntragAnnahmecheck
          </span></v-col
        >
      </v-row>

      <v-row v-if="!sharedDataStore.isMobile()">
        <v-col cols="12">
          Sie erfahren
          <strong class="text-green">jetzt sofort</strong>
          (Zeitaufwand ca. 30 Sekunden):
          <ol class="body-1 pt-1 ml-4">
            <li>
              welche Tarife abschließbar sind (<b>AntragAnnahmecheck</b>). 100 %
              anonym.
            </li>
            <li>
              welche
              <strong>Zahnzusatzversicherung</strong> am besten für Sie geeinet
              ist
            </li>
            <li>
              <b>wieviel die besten Tarife kosten</b> und wie diese getestet
              wurden
            </li>
          </ol>
        </v-col>
      </v-row>
    </div>

  

   

    <!-- Form first row -->
    <v-form
      ref="berechnungFormRef"
      v-show="!berechnung_submited"
      @submit.prevent="submitBerechnung"
    >
      <!-- ber_jahr, 
                   ber_monat 
                            ber tag - Geburtstag-->

      <v-row>
        <v-col cols="12" md="3" class="subheading"
          >Ihr <b>Geburtstag</b>
          <span v-if="berechnung.ber_erst == 1">
            <br />
            <a @click="resetAll()">neue Person berechnen</a>
          </span>
        </v-col>
        <v-col cols="12" md="9">
          <input-geburtstag-select
            :key="componentKeyStatus"
            v-on:update:year="yearChanged"
            v-on:update:month="monthChanged"
            v-on:update:day="dayChanged"
            :year="berechnung.ber_jahr"
            :month="berechnung.ber_monat"
            :day="berechnung.ber_tag"
        /></v-col>
      </v-row>

      <v-divider class="blue my-2"></v-divider>

      <div
        v-if="showKfoInfo && berechnung.ber_segment < 2"
        class="pa-2 my-4 mit_ohne_KFO"
        style="border-right: 4px solid #fecf0c"
      >
        <h3>Tarife mit Leistung für Kieferorthopädie?</h3>
        <p>
          Soll die gesuchte Zahnzusatzversicherung noch für Kieferorthopädie
          &nbsp; Zahnspangen leisten, oder benötigen Sie das nicht mehr?
        </p>

        <wtb-check-box
          label-data="Kieferorthopädie soll mitversichert werden"
          class="headline"
          :input="berechnung.ber_kfoja"
          @update:input="updateValueBer('ber_kfoja', $event)"
        />

        <p>
          <b>Wichtig:</b> eine Versicherung mit Leistungen für Zahnspangen
          können Sie nur dann abschließen, wenn aktuell noch keine
          Zahnfehlstellung bei Ihrem Kind diagnostiziert worden ist!
        </p>
      </div>

      <!-- ber_geschlecht - Geschlecht -->

      <v-row>
        <v-col cols="12" md="7">Ihr <b>Geschlecht</b></v-col>
        <v-col cols="12" md="5">
          <v-radio-group class="pl-4 ma-0" v-model="berechnung.ber_geschlecht">
            <v-row>
              <v-col md="6" style="min-width: 80px">
                <v-radio
                  key="0"
                  label="Frau"
                  color="green"
                  :value="0"
                ></v-radio>
              </v-col>

              <v-col md="6" style="min-width: 80px">
                <v-radio
                  key="1"
                  label="Mann"
                  color="green"
                  :value="1"
                ></v-radio>
              </v-col>
            </v-row> </v-radio-group
        ></v-col>
      </v-row>

      <v-divider class="blue my-2"></v-divider>

      <v-row>
        <v-col cols="12" md="7" class="subheading"
          >Wie sind Sie <b>versichert</b>?</v-col
        >
        <v-col cols="12" md="5">
          <v-select
            background-color="white"
            v-model="berechnung.ber_gesetzl"
            :items="versicherungsArten"
            item-value="id"
            item-title="name"
            single-line
          ></v-select>
          <span v-if="berechnung.ber_segment < 2">
            <wtb-check-box
              label-data="möchte  Zahnversicherung wechseln"
              color="green"
              class="caption"
              @change="showTarifSuche()"
              :input="berechnung.ber_wechsel"
              @update:input="updateValueBer('ber_wechsel', $event)"
            />
          </span>
        </v-col>
      </v-row>
      <div
        v-if="berechnung.ber_gesetzl == '2' && berechnung.ber_segment < 2"
      >
   
            <berechnung-form-row>
          <template v-slot:title>
            <div>
             Wieviel leistet Ihr <b class="text-green">private Krankenversicherung</b>> für zahnärztliche Leistungen (in Prozent)?
            </div>
            <div class="caption"></div>
          </template>

          <template v-slot:input>
            <v-text-field
              maxlength="5"
              minlength="5"
              label="Erstattung für zahnärztliche Leistungen in Ihrer PKV in %"
              v-model="berechnung.ber_pkv_zahn_erstattung"
            />
          </template>
        </berechnung-form-row>
      </div>

<!-- 
      <v-alert
        border="bottom"
        colored-border
        color="blue"
        dismissible
        v-show="berechnung.ber_gesetzl == '2' && berechnung.ber_segment < 2"
        >Wenn Sie in der PKV (privaten Krankenversicherung) versichert sind,
        können Sie keine "normale" Zahnzusatzversicherung beantragen.</v-alert
      > -->

      <v-divider class="mb-3"></v-divider>

      <!-- Start Brille -->
      

      <!-- Ende Brille -->

      <!-- Start Zähne -->
      <div v-if="berechnung.ber_segment < 2">
        <!-- #bayplz -->
        <v-row>
          <v-col cols="12" md="8">
            <b>Ihre Postleitzahl?</b> Bitte geben Sie die Postleitzahl Ihres
            Wohnortes <br /><b>5-stellig</b>. Einige Tarife gewähren je nach
            Wohnort einen günstigeren Beitrag.
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              maxlength="5"
              minlength="5"
              v-model="berechnung.ber_plz"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8">
            Läuft gerade eine
            <strong>zahnärztliche Behandlung</strong>
            oder wurde empfohlen?

            <div class="caption">
              außer Aufbiss-Schienen und prof. Zahnreinigung (PZR)
              <a v-on:click="showBerZahnmassInfo = !showBerZahnmassInfo"
                >Erklärung anzeigen</a
              >
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-radio-group
              class="pl-4 ma-0"
              v-model="berechnung.ber_zahnmass"
              @change="berMassnahmeChanged($event)"
            >
              <v-row>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="1"
                    label="Ja"
                    color="green"
                    :value="1"
                  ></v-radio>
                </v-col>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="0"
                    label="Nein"
                    color="green"
                    :value="0"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-alert
          dismissible
          border="bottom"
          colored-border
          color="blue"
          v-if="showBerZahnmassInfo"
          type="info"
        >
          <zahnmass-info class="body-2" />
        </v-alert>

        <div
          class="pl-4"
          v-show="berechnung.ber_zahnmass == 1 && berechnung.ber_alter > 17"
        >
          <!-- <v-row >
                  <v-col cols="12" md="9">
                    Die
                    <strong>zahnärztliche Behandlung</strong>
                    wurde bereits vor mehr als 2 Jahre angeraten?
                    <div class="caption"></div>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-radio-group
                      class="pl-4 ma-0"
                      v-model="berechnung.ber_zahnmass_2"
                    >
                     <v-row>
                        <v-col cols="12" md="6" style="min-width: 80px">
                          <v-radio
                            key="1"
                            label="Ja"
                            color="green"
                            :value="1"
                          ></v-radio>
                        </v-col>
                        <v-col cols="12" md="6" style="min-width: 80px">
                          <v-radio
                            key="0"
                            label="Nein"
                            color="green"
                            :value="0"
                          ></v-radio>
                        </v-col>
                     </v-row>
                    </v-radio-group>
                  </v-col>
                </v-row> -->

          <v-row>
            <v-col cols="12" md="8">
              Soll diese Behandlung von Ihrer Versicherung
              <b>bereits bezahlt werden</b>? (ist gegen Aufschlag möglich)
              <div class="caption"></div>
            </v-col>
            <v-col cols="12" md="4">
              <v-radio-group class="pl-4 ma-0" v-model="berechnung.ber_sofort">
                <v-row>
                  <v-col cols="6" style="min-width: 80px">
                    <v-radio
                      key="1"
                      label="Ja"
                      color="green"
                      :value="1"
                    ></v-radio>
                  </v-col>
                  <v-col cols="6" style="min-width: 80px">
                    <v-radio
                      key="0"
                      label="Nein"
                      color="green"
                      :value="0"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
        </div>

        <v-divider class="blue my-2"></v-divider>

        <!-- ber_aufbiss - Aufbiss, Zahnschiene -->
        <v-row>
          <v-col cols="12" md="8">
            Haben Sie eine
            <strong>Aufbiss</strong>-bzw. <strong>Zahnschiene</strong>?
            <br />
            <a
              class="caption"
              v-on:click="showBerAufbissInfo = !showBerAufbissInfo"
              >Detaillierte Erklärung...</a
            >
          </v-col>
          <v-col cols="12" md="4">
            <v-radio-group class="pl-4 ma-0" v-model="berechnung.ber_aufbiss">
              <v-row>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="1"
                    label="Ja"
                    color="green"
                    :value="1"
                  ></v-radio>
                </v-col>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="0"
                    label="Nein"
                    color="green"
                    :value="0"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-alert
          border="bottom"
          colored-border
          color="blue"
          dismissible
          v-if="showBerAufbissInfo"
          type="info"
        >
          <aufbiss-info class="body-2" />
        </v-alert>

        <v-divider class="blue my-2"></v-divider>

        <!-- ber_zahnfehl - Zahnfehlstellung -->
        <v-row>
          <v-col cols="12" md="8">
            Besteht eine
            <strong>ärztlich festgestellte Zahnfehlstellung</strong>?

            <div class="caption">
              Wurde bereits eine kieferorthopädische Behandlung empfohlen?
              <a v-on:click="showBerZahnfehlInfo = !showBerZahnfehlInfo"
                >Ausführliche Erklärung...</a
              >
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-radio-group class="pl-4 ma-0" v-model="berechnung.ber_zahnfehl">
              <v-row>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="1"
                    label="Ja"
                    color="green"
                    :value="1"
                  ></v-radio>
                </v-col>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="0"
                    label="Nein"
                    color="green"
                    :value="0"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-alert
          border="bottom"
          colored-border
          color="blue"
          dismissible
          v-if="showBerZahnfehlInfo"
          type="info"
        >
          <zahnfehl-info class="body-2" />
        </v-alert>

        <v-divider class="blue my-2"></v-divider>

        <!-- ber_zb_3 - Parodontosebehandlung -->

        <v-row v-if="berechnung.ber_alter > 6">
          <v-col cols="12" md="8">
            Wurde bei Ihnen bereits eine
            <strong>Parodontosebehandlung</strong>
            durchgeführt?
            <a class="caption" v-on:click="showBerZb3Info = !showBerZb3Info"
              >Mehr Infos anzeigen...</a
            >
          </v-col>
          <v-col cols="12" md="4">
            <v-radio-group class="pl-4 ma-0" v-model="berechnung.ber_zb_3">
              <v-row>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="1"
                    label="Ja"
                    color="green"
                    :value="1"
                  ></v-radio>
                </v-col>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="0"
                    label="Nein"
                    color="green"
                    :value="0"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-alert
          border="bottom"
          colored-border
          color="blue"
          dismissible
          v-if="showBerZb3Info"
          type="info"
        >
          <zb3-info class="body-2" />
        </v-alert>

        <v-divider
          v-if="berechnung.ber_alter > 6"
          class="blue my-2"
        ></v-divider>

        <!-- ber_ze_ja - Fehlzahn -->
        <v-row v-if="berechnung.ber_alter > 6">
          <v-col cols="12" md="8">
            Haben Sie
            <b>fehlende</b> oder <b>ersetzte</b> Zähne?

            <div class="caption">
              <b class="text-green">Ersetzte Zähne sind z.B:</b>
              Kronen, Implantate, Veneers, Prothesen und Brücken - bitte Frage
              mit "
              <b>ja</b>" beantworten
              <br />
              <b>Fehlende Zähne sind nicht:</b>
              Weisheitszähne, Milchzähne, sog ."Lückenschlüsse" - bitte Frage
              mit "
              <b>nein</b>" beantworten
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-radio-group
              class="pl-4 ma-0"
              v-model="berechnung.ber_ze_ja"
              @change="berZeChanged($event)"
            >
              <v-row>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="1"
                    label="Ja"
                    color="green"
                    :value="1"
                  ></v-radio>
                </v-col>
                <v-col cols="6" style="min-width: 80px">
                  <v-radio
                    key="0"
                    label="Nein"
                    color="green"
                    :value="0"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>

        <!-- Fehlende zähne - zusätzliche Fragen -->
        <div
          v-show="
            (berechnung.ber_ze_ja == 1 || berechnung.ber_luecke > 0) &&
            berechnung.ber_alter > 6
          "
          style="padding-left: 30px"
        >
          <!-- ber_luecke: Wie viele fehlzähne? -->
          <berechnung-form-row>
            <template v-slot:title>
              <div>
                Wie viele <strong>Zähne fehlen</strong> Ihnen, die nicht ersetzt
                wurden oder sind bereits zum Ziehen angeraten?
              </div>
              <div class="caption">
                Der Rechner sucht Tarife, die
                <strong>fehlende Zähne mitversichern.</strong>
                <br />
                <a v-on:click="showBerLueckeInfo = !showBerLueckeInfo"
                  >Mehr Infos..</a
                >
              </div>
            </template>
            <template v-slot:input>
              <v-select
                background-color="white"
                v-model="berechnung.ber_luecke"
                :items="berLueckeSelect"
                item-title="name"
                item-value="id"
                single-line
                @update:modelValue="berLueckeChanged"
              ></v-select>
            </template>
          </berechnung-form-row>

          <v-alert
            border="bottom"
            colored-border
            color="blue"
            dismissible
            v-if="showBerLueckeInfo"
            type="info"
          >
            <luecke-info class="body-2" />
          </v-alert>

          <berechnung-form-row v-if="berechnung.ber_luecke != 0">
            <template v-slot:title>
              <div>
                Wollen Sie bereits bestehende Lücken
                <strong class="text-green">mitversichern</strong>?
                <span
                  class="caption"
                  v-if="berechnung.ber_luecke > 0 && berechnung.ber_luecke < 3"
                >
                  <br />Bei einem fehlenden Zahn, empfehlen wir Ihnen
                  <strong class="text-green">diese zu versichern</strong>. Dies
                  ist oft kostenlos möglich. Bei mehreren fehlenden Zähnen ist
                  dies teilweise mit Aufschlag möglich.
                </span>
              </div>
            </template>
            <template v-slot:input>
              <wtb-check-box
                label-data="Ja"
                color="green"
                class="headline"
                :input="berechnung.ber_luecke_vers"
                @update:input="updateValueBer('ber_luecke_vers', $event)"
              />
            </template>
          </berechnung-form-row>

          <v-divider class="blue my-2"></v-divider>

          <berechnung-form-row>
            <template v-slot:title>
              <div>
                Anzahl der durch herausnehmbare
                <strong>Prothesen</strong>
                ersetzten Zähne?
                <br />
                <a
                  class="caption"
                  v-on:click="showBerZahnersetztInfo = !showBerZahnersetztInfo"
                  >Mehr Infos dazu...</a
                >
              </div>
            </template>
            <template v-slot:input>
              <v-select
                background-color="white"
                v-model="berechnung.ber_zahnersetzt"
                :items="berLueckeSelect"
                item-title="name"
                item-value="id"
                single-line
              ></v-select>
            </template>
          </berechnung-form-row>

          <berechnung-form-row v-if="berechnung.ber_zahnersetzt != 0">
            <template v-slot:title>
              <div>
                Haben Sie ersetzte Zähne/Prothesen die älter als 10 Jahre sind?
              </div>
            </template>
            <template v-slot:input>
              <wtb-check-box
                label-data="Ja"
                color="green"
                class="headline"
                :input="berechnung.ber_zahnersatz_10"
                @update:input="updateValueBer('ber_zahnersatz_10', $event)"
              />
            </template>
          </berechnung-form-row>

          <v-alert
            border="bottom"
            colored-border
            color="blue"
            dismissible
            v-if="showBerZahnersetztInfo"
            type="info"
          >
            <zahnersetzt-info class="body-2" />
          </v-alert>

          <v-divider class="blue my-2"></v-divider>

          <berechnung-form-row>
            <template v-slot:title>
              <div>
                Wie viele
                <strong>Brücken</strong> haben Sie?
                <br />
                <a
                  class="caption"
                  v-on:click="showBerBrueckeInfo = !showBerBrueckeInfo"
                  >Erklärung anzeigen</a
                >
              </div>
            </template>
            <template v-slot:input>
              <v-select
                background-color="white"
                v-model="berechnung.ber_bruecke"
                :items="berLueckeSelect"
                item-title="name"
                item-value="id"
                single-line
              ></v-select>
            </template>
          </berechnung-form-row>

          <v-alert
            border="bottom"
            colored-border
            color="blue"
            dismissible
            v-if="showBerBrueckeInfo"
            type="info"
          >
            <bruecke-info class="body-2" />
          </v-alert>

          <v-divider class="blue my-2"></v-divider>

          <berechnung-form-row>
            <template v-slot:title>
              <div>
                Wie viele (Teil-)
                <strong>Kronen</strong> und <strong>Implantate</strong> haben
                Sie?
                <br />
                <a
                  class="caption"
                  v-on:click="showBerKronenInfo = !showBerKronenInfo"
                  >Detail-Infos anzeigen</a
                >
              </div>
            </template>
            <template v-slot:input>
              <v-select
                background-color="white"
                v-model="berechnung.ber_kronen"
                :items="berLueckeSelect"
                item-title="name"
                item-value="id"
                single-line
              ></v-select>
            </template>
          </berechnung-form-row>

          <v-alert
            border="bottom"
            colored-border
            color="blue"
            dismissible
            v-if="showBerKronenInfo"
            type="info"
          >
            <kronen-info class="body-2" />
          </v-alert>

          <v-divider class="blue my-2"></v-divider>
        </div>
        <!-- ENDE FZ -->
      </div>
      <!-- Ende Zahnfragen -->
      <!-- ErstInformationen -->

      <v-row class="py-4 pl-2" v-if="berechnung.ber_erst == 0">
        <v-col cols="12" md="1">
          <v-checkbox
            color="green"
            @click="erstInfoChecked()"
            :rules="validateCheckbox()"
            class="py-0 my-0"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="11">
          <h3>
            <span class="text-green">Ja,</span> ich habe die Erstinformation für
            Kunden erhalten
          </h3>

          <a @click="erstInfoChecked()">
            Erstinformationen für Versicherungsmakler
          </a>
          gemäß § 15 VersVermV
          <a @click="showErstInfoPop = !showErstInfoPop"
            >jetzt anzeigen oder herunterladen.</a
          >
          <p v-if="errorMessage" class="text-orange">{{ errorMessage }}</p>
        </v-col>
      </v-row>

      <v-row class="py-4 pl-2" v-if="berechnung.ber_erst == 0 && berErstError">
        <v-col cols="12"
          ><h3 class="text-orange">
            Bitte setzen Sie den Haken auf "Ja" um eine Berechnung zu starten
          </h3></v-col
        >
      </v-row>
      <v-row
        pa-4
        v-if="
          sucheTarife &&
          berechnung.ber_segment <= 1 &&
          berechnung.ber_wechsel == 1
        "
      >
        <v-col cols="12">
          <h3>
            <span class="text-green">Optional:</span>
            welche Zahnzusatzversicherungen haben Sie bis jetzt?
          </h3>
          <v-text-field
            v-model="search"
            background-color="white"
            type="text"
            label="Name Ihrer Zahnzusatzversicherung (die Sie wechseln wollen)"
          ></v-text-field>

          <br />
          <span v-if="filteredTarife && search">
            <b
              >Wählen Sie jetzt Ihre Zahnzusatzversicherung aus (wenn
              möglich)</b
            >
            <br />

            <v-radio-group v-model="berechnung.ber_wechsel_tarif_id">
              <v-radio
                @click="setWechselTarif(tarif.tarif_id, tarif.tarif_name)"
                v-for="tarif in filteredTarife"
                :key="`tarifsuche${tarif.tarif_id}`"
                :value="tarif.tarif_id"
                :label="tarif.tarif_name"
              ></v-radio>
            </v-radio-group>
          </span>
        </v-col>
      </v-row>

      <!-- Submit Berechnung -->
      <v-row class="py-4 pl-2" v-if="showGeburtstagFehler">
        <v-col cols="12"
          ><h3 class="text-orange">
            Bitte geben Sie ein Geburtsdatum an
          </h3></v-col
        >
      </v-row>

      <v-row class="white">
        <v-col cols="12">
          <wtb-check-box
            v-if="
              berechnung.ber_erst == 1 &&
              berechnung.ber_segment <= 1 &&
              berechnung.ber_alter > 17
            "
            label-data="wollen Sie Bleaching mitversichern?"
            color="green"
            class="caption"
            :input="berechnung.ber_bleaching"
            @update:input="updateValueBer('ber_bleaching', $event)"
          />
          <v-btn
            :color="showBtnColor"
            style="height: 48px"
            elevated
            tile
            rounded="0"
            type="submit"
            class="button_caps"
            tonal
            value="jetzt Berechnung starten &nbsp; Ergebnis anzeigen"
          >
            <span class="text-white" v-if="!sharedDataStore.isMobile()">
              <b style="font-size: 24px">Vergleich starten | </b
              ><span style="font-size: 24px">jetzt hier klicken</span>
            </span>
            <span v-if="sharedDataStore.isMobile()" style="font-size: 24px">
              Vergleich starten
            </span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h3>Der Rechner zeigt Ihnen sofort:</h3>
          <ul v-if="berechnung.ber_segment == 2">
            <li>die leistungstärksten Zusatzversicherungen für Sehhilfen</li>
          </ul>

         

          <!-- ZahnOnly -->
          <ul v-if="berechnung.ber_segment < 2" class="ml-4">
            <li v-if="wechselTarifName">
              Sie wollen diesen Tarif wechseln:
              <strong class="text-green">{{ wechselTarifName }}</strong>
            </li>
            <li v-show="berechnung.ber_alter < 9">
              die leistungstärksten Zahnzusatzversicherungen für Kinder |
              <strong class="text-green"
                >{{ berechnung.ber_alter }} Jahre</strong
              >
            </li>
            <li v-show="berechnung.ber_alter >= 9 && berechnung.ber_alter < 18">
              die leistungstärksten Zahnzusatzversicherungen für Jugendlichen |
              <strong class="text-green"
                >{{ berechnung.ber_alter }} Jahre</strong
              >
            </li>
            <li
              v-show="
                berechnung.ber_luecke_vers == 1 &&
                berechnung.ber_luecke > 0 &&
                berechnung.ber_alter > 18
              "
            >
              Tarife die bereits fehlende Zähne mitversichern
            </li>

            <li v-show="berechnung.ber_kfoja == '1'">
              Tarife mit möglichst hohen Kieferorthopädie-Leistungen
            </li>
            <li v-show="berechnung.ber_alter >= 18">
              die leistungstärksten Zahnzusatzversicherungen | Eintrittsalter:
              <strong class="text-green"
                >{{ berechnung.ber_alter }} Jahre</strong
              >
            </li>
            <li v-show="berechnung.ber_alter >= 60">
              die besten Zahnzusatzversicherungen mit möglichst hohen Leistungen
              für Prothetik, Implantate und Zahnersatz.
            </li>
            <li>
              Zahnzusatzversicherungen mit dem besten Preis-Leistungsverhältnis
            </li>
            <li v-show="berechnung.ber_zahnmass == 1">
              Tarife die Sie
              <strong>trotz laufender Behandlung</strong>
              beantragen können
            </li>
            <li v-show="berechnung.ber_zahnfehl == 1">
              Tarife die Sie
              <strong>auch mit einer Zahnfehlstellung</strong>
              beantragen können
            </li>
            <li v-show="berechnung.ber_zb_3 == 1">
              Tarife die Sie
              <strong>trotz laufender Paradontose</strong>
              beantragen können
            </li>
            <li v-show="berechnung.ber_aufbiss == 1">
              Tarife die
              <strong class="text-green">Aufbiss-Schienen</strong>
              mitversichern
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-form>
    <v-row>
      <v-dialog width="777" v-model="showErstInfoPop">
        <v-card>
          <erst-info-pop />
        </v-card>
      </v-dialog>
    </v-row>
    <div v-if="appLoaded" id="appLoaded"></div>
  </div>
</template>

<script setup>
  import {
    ref,
    reactive,
    getCurrentInstance,
    watchEffect,
    computed,
    onMounted,
    defineEmits,
    watch,
  } from "vue";
  import WtbCheckBox from "@/components/berechnung/form/WtbCheckBox";
  import BerechnungFormRow from "@/components/berechnung/form/BerechnungFormRow";
  import InputGeburtstagSelect from "@/components/berechnung/form/InputFormGeburtstagSelect";
  import ZahnmassInfo from "@/components/berechnung/info/ZahnmassInfo";
  import AufbissInfo from "@/components/berechnung/info/AufbissInfo";
  import ZahnfehlInfo from "@/components/berechnung/info/ZahnfehlInfo";
  import Zb3Info from "@/components/berechnung/info/Zb3Info";
  import LueckeInfo from "@/components/berechnung/info/LueckeInfo";
  import ZahnersetztInfo from "@/components/berechnung/info/ZahnersetztInfo";
  import BrueckeInfo from "@/components/berechnung/info/BrueckeInfo";
  import KronenInfo from "@/components/berechnung/info/KronenInfo";
  import ErstInfoPop from "@/components/berechnung//info/ErstInfoPop";
  import { useBerechnungStore } from "@/stores/berechnung";
  import { useSharedDataStore } from "@/stores/sharedData";
  import { useGuestStore } from "@/stores/guest";
  import BaseCalls from "@/services/BaseCalls";

  const guestStore = useGuestStore();
  const sharedDataStore = useSharedDataStore();
  const emit = defineEmits(["updateBerechnung"]);
  
  const berechnungStore = useBerechnungStore();
  const { proxy } = getCurrentInstance();

  const showBerZahnmassInfo = ref(false);
  const showBerAufbissInfo = ref(false);
  const showBerZahnfehlInfo = ref(false);
  const showBerZb3Info = ref(false);
  const showBerLueckeInfo = ref(false);
  const showBerZahnersetztInfo = ref(false);
  const showBerBrueckeInfo = ref(false);
  const showBerKronenInfo = ref(false);
  const showKfoInfo = ref(false);
  const showErstInfoPop = ref(false);
  const componentKeyStatus = ref(0);
  const routeSegment = ref(1);
  const appLoaded = ref(true);
  const showGeburtstagFehler = ref(false);
  const berechnung = reactive({
    ber_guest_id: 0,
    ber_rechner_type: 1,
    ber_wechsel_tarif_id: 0,
    ber_annahme_tarif_id: 0,
    ber_kunden_id: "0",
    ber_segment: 1,
    ber_wechsel: 0,
    ber_alter: 0,
    ber_plz: "",
    ber_aufbiss: 0,
    ber_bruecke: 0,
    ber_bleaching: 0,
    ber_kronen: 0,
    ber_geschlecht: 1,
    ber_gesetzl: 1,
    ber_pkv_zahn_erstattung: 0,
    ber_zahnmass: 0,
    ber_zahnmass_2: 1,
    ber_sofort: 0,
    ber_tag: new Date().getDate(),
    ber_monat: new Date().getMonth() + 1,
    ber_jahr: new Date().getFullYear(), // Änderung: Verwende getFullYear statt getYear + 1900
    ber_zb_3: 0,
    ber_zahnfehl: 0,
    ber_ze_ja: 0,
    ber_luecke: 0,
    ber_luecke_vers: 0,
    ber_zahnersetzt: 0,
    ber_zahnersatz_10: 0,
    ber_kfoja: 0,
    ber_screen_size: window.innerWidth, // Beachte: Die Verwendung von `screen.width` ist statisch; `window.innerWidth` reflektiert die tatsächliche Fensterbreite
    ber_erst: 0,
    ber_brille_ja: 0,
    ber_brille_dioptrien: 0,
    ber_brille_krankheit: 0,
    ber_brille_sonnenbrille: 0,
    ber_brille_gleitsicht: 0,
    ber_hoergeraet_versicherung: 0,
    ber_hoergeraet_massnahme: 0,
    ber_brille_lasik: 0,
    ber_top_gesund: 0,
  });

  const defaultValues = reactive({
    ...berechnung,
  });

  const versicherungsArten = ref([
    { id: 1, name: "gesetzliche Krankenkasse" },
    { id: 2, name: "private Krankenversicherung" },
    { id: 3, name: "Heilfürsorge" },
    { id: 4, name: "gesetzliche Krankenkasse & Beihilfe" },
    { id: 5, name: "freie Heilfürsorge & Beihilfe" },
  ]);

  const berLueckeSelect = ref([
    { id: "0", name: "0" },
    { id: "1", name: "1" },
    { id: "2", name: "2" },
    { id: "3", name: "3" },
    { id: "4", name: "4" },
    { id: "5", name: "5" },
    { id: "6", name: "6" },
    { id: "7", name: "7" },
    { id: "8", name: "8" },
    { id: "9", name: "9" },
    { id: "10", name: "10" },
    { id: "11", name: "11" },
    { id: "12", name: "12" },
    { id: "13", name: "13" },
    { id: "14", name: "14" },
    { id: "15", name: "mehr als 14" },
  ]);
  const berechnung_submited = ref(false);
  const wechselTarifName = ref(false);
  const berechnungFormRef = ref(null);
  const sucheTarife = ref([]);
  const search = ref("");
  const isChecked = ref(false);
  const errorMessage = ref("");
  const berErstError = ref(false);

  const resetAll = () => {
    console.log("reset berechnung");
    Object.assign(berechnung, defaultValues);
  };
  // Validierungsfunktion
  const validateCheckbox = () => {
    if (!isChecked.value) {
      errorMessage.value =
        "Sie müssen den Bedingungen zustimmen, um fortzufahren.";
    } else {
      errorMessage.value = "";
    }
  };
  function showTarifSuche() {
    if (berechnung.ber_wechsel == 1) {
      getAlleZahnTarife();
    }
  }
  function checkCurrentDate() {
    const heute = new Date();
    const aktuellesJahr = heute.getFullYear();
    const aktuellerMonat = heute.getMonth() + 1; // Monate sind 0-basiert, daher +1
    const aktuellerTag = heute.getDate();

    if (
      berechnung.ber_jahr === aktuellesJahr &&
      berechnung.ber_monat === aktuellerMonat &&
      berechnung.ber_tag === aktuellerTag
    ) {
      return true;
    } else {
      return false;
    }
  }
  function checkBerechnung() {
    let checkPassed = true;
    showGeburtstagFehler.value = false;
    if (checkCurrentDate()) {
      showGeburtstagFehler.value = true;
    }
    if (berechnung.ber_erst == 0) {
      checkPassed = false;
      berErstError.value = true;
      console.log("ber_erst check");
    }
    if (berechnungFormRef.value && !berechnungFormRef.value.validate()) {
      checkPassed = false;
      console.log("checkPassfalse");
    }
    console.log("checkPassed" + checkPassed);
    return checkPassed;
  }

  async function getAlleZahnTarife() {
    let select = {};
    select.action = "getAlleZahnTarife";
    try {
      const resp = await BaseCalls.postTarif(select); // Korrigiert, um .value zu verwenden
      if (resp.data && resp.data.tarife) {
        sucheTarife.value = resp.data.tarife;
      }
    } catch (err) {
      console.log("error tarife");
    }
  }
  async function submitBerechnung() {
    if (!checkBerechnung()) {
      return false;
    }

    // berechnung.token =
    //   "92418073005bd16ead01dcfcb713a5e580cf171c66982171ef08ff2169f94f93";
    berechnung.action = "insertBerechnung";
    berechnung.berGestartet = true;
    console.log("berechnung gestartet");
    try {
      const resp = await BaseCalls.postBerechnung(berechnung); // Korrigiert, um .value zu verwenden

      if (resp.data && resp.data.berechnung) {
        console.log("insert erfolgreich" + resp.data.berechnung);
        berechnungStore.setBerechnung(resp.data.berechnung);
      }
    } catch (err) {
      console.log("error berechnung");
    }
  }

  const updateValueBer = (key, newValue) => {
    console.log("New: " + newValue);
    berechnung[key] = newValue;
  };
  

  const filteredTarife = computed(() => {
    if (sucheTarife.value.length > 1) {
      return sucheTarife.value.filter((tarif) =>
        tarif.tarif_name.toLowerCase().includes(search.value.toLowerCase())
      );
    }
    return []; // Sicherer Fallback, falls sucheTarife.value kein Array ist
  });
  function dayChanged(day) {
    // $log.debug(`day changed: ${day}`)
    berechnung.ber_tag = day;
    handleBirthdayChanged();
  }
  function monthChanged(month) {
    berechnung.ber_monat = month;
    handleBirthdayChanged();
  }
  function yearChanged(year) {
    berechnung.ber_jahr = year;
    handleBirthdayChanged();
  }

  function handleBirthdayChanged() {
    showGeburtstagFehler.value = false;
    calcAge();

    if (berechnung.ber_alter <= 6) {
      berechnung.ber_luecke = "0";
      berechnung.ber_luecke_vers = "0";
      berechnung.ber_kronen = "0";
      berechnung.ber_ze_ja = "0";
      berechnung.ber_bruecke = "0";
      berechnung.ber_zahnersetzt = "0";
      berechnung.ber_zb_3 = "0";
    }

    if (berechnung.ber_alter <= 9) {
      showKfoInfo.value = false;
      berechnung.ber_kfoja = "1";
    }

    if (berechnung.ber_alter >= 10 && berechnung.ber_alter <= 17) {
      showKfoInfo.value = true;
      berechnung.ber_kfoja = "1";
    }

    if (berechnung.ber_alter >= 18) {
      berechnung.ber_kfoja = "0";
      showKfoInfo.value = false;
    }
  }

  function calcAge() {
    // let age = DateHelper.calcAge(
    //   berechnung.ber_tag,
    //   berechnung.ber_monat,
    //   berechnung.ber_jahr
    // );
    let age = proxy.$calcAge(
      berechnung.ber_tag,
      berechnung.ber_monat,
      berechnung.ber_jahr
    );
    berechnung.ber_alter = age;
  }
  function setWechselTarif(tarif_id, tarif_name) {
    berechnung.ber_wechsel_tarif_id = tarif_id;
    wechselTarifName.value = tarif_name;
  }
  function erstInfoChecked() {
    berechnung.ber_erst = 1;
  }

  function berMassnahmeChanged() {
    if (berechnung.ber_zahnmass == "0") {
      berechnung.ber_sofort = "0";
    }
  }
  function berZeChanged() {
    console.log("berZeChanged");
    if (berechnung.ber_ze_ja == "0") {
      berechnung.ber_luecke = "0";
      berechnung.ber_luecke_vers = "0";
    }
  }

  function berLueckeChanged(value) {
    console.log("berLueckeChanged");
    if (value == 0) {
      berechnung.ber_luecke_vers = 0;
    } else if (value > 0 && value <= 1) {
      berechnung.ber_luecke_vers = 1;
    } else {
      berechnung.ber_luecke_vers = 0;
    }
  }

  const showBtnColor = computed(() => {
    return "#2196F3";
    
  });

  const showSegmentType = computed(() => {
    return "starten";
  });

  watchEffect(() => {
    if (berechnungStore.berechnung) {
      componentKeyStatus.value = componentKeyStatus.value + 1;

      // Iteriere durch die Schlüssel des neuen Objekts und aktualisiere das reaktive Objekt

      Object.keys(berechnungStore.berechnung).forEach((key) => {
        if (key !== "ber_guest_id") {
          berechnung[key] = berechnungStore.berechnung[key];
        }
        if (
          guestStore.guest.guest_id !== 0 &&
          berechnungStore.berechnung["ber_guest_id"] !==
            guestStore.guest.guest_id
        ) {
          berechnung["ber_guest_id"] = guestStore.guest.guest_id;
        } else {
          berechnung["ber_guest_id"] =
            berechnungStore.berechnung["ber_guest_id"];
        }
        console.log(guestStore.guest.guest_id);
      });
      if (berechnung.ber_segment != routeSegment.value) {
        // console.log("berechnung.ber_segment != routeSegment.value");
        berechnung.ber_segment = routeSegment.value;
      }
    }
  });
  onMounted(() => {

    routeSegment.value = 1;
    berechnung.ber_segment = routeSegment.value;
    // if (routeSegment.value == 1 && sucheTarife.value.length == 0) {
    //   getAlleZahnTarife();
    // }
  });
  watch(berechnung, (newValue) => {
    emit("updateBerechnung", newValue); // Emit das Update Event mit dem neuen Wert
  });
</script>
